var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.168 18.578c0-.585.435-1.07 1-1.146l.156-.01H30.45a1.156 1.156 0 0 1 .157 2.302l-.157.01H7.324a1.156 1.156 0 0 1-1.156-1.156Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.307 10.11a1.156 1.156 0 0 1 1.502-1.751l.13.112 9.327 9.287c.413.41.45 1.055.113 1.508l-.113.13-9.327 9.289a1.156 1.156 0 0 1-1.744-1.51l.112-.129 8.504-8.47-8.504-8.467Z",
    fill: "#fff"
  })));
};
export default SvgArrowLeft;